<template>
  <div class="editor-steps-block">
    <steps :current="step" direction="vertical">
      <step
        v-for="step in steps"
        :key="step.index"
        :title="step.title"
        :content="step.content"
        @click.native="changeStep(step.index)"
      />
    </steps>
  </div>
</template>

<script>
export default {
  props: ['steps', 'step'],
  methods: {
    changeStep (step) {
      this.$emit('change-step', step)
    }
  }
}
</script>

<style lang="less">
  .editor-steps-block {
    .ivu-steps {
      &-head, &-title {
        background: transparent;
      }

      &-item {
        cursor: pointer;
      }
    }
  }
</style>
